<template>
  <b-container class="bv-example-row event-highlights-section">
    <b-row>
      <b-col class="mb-4">
        <button
          @click="component = 'statistics'"
          :class="{
            'tab-btn-active': component === 'statistics',
            'tab-btn': component !== 'statistics',
          }"
        >
          <i class="fa fa-bar-chart"></i>
          <p>Statistics</p>
        </button>
        <br />
        <button
          :class="{
            'tab-btn-active': component === 'video',
            'tab-btn': component !== 'video',
          }"
          @click="component = 'video'"
        >
          <i class="fas fa-video"></i>
          <p>Video</p>
        </button>
        <br />
        <button
          :class="{
            'tab-btn-active': component === 'photos',
            'tab-btn': component !== 'photos',
          }"
          @click="component = 'photos'"
        >
          <i class="fas fa-images"></i>
          <p>Photos</p>
        </button>
        <br />
        <button
          :class="{
            'tab-btn-active': component === 'media',
            'tab-btn': component !== 'media',
          }"
          @click="component = 'media'"
        >
          <i class="fas fa-book-open"></i>
          <p>Guide</p>
        </button>
      </b-col>
      <b-col cols="10">
        <div class="mt-3 mb-4" v-if="component === 'statistics'">
          <b-row class="justify-content-md-center">
            <b-col>
              <img class="event-statistics-img" :src="event.statistics" />
            </b-col>
          </b-row>
        </div>
        <vue-plyr class="mt-3 mb-4" v-if="component === 'video'">
          <div
            v-if="event.highlights"
            :data-plyr-provider="getHostName(event.highlights)"
            :data-plyr-embed-id="event.highlights"
          ></div>
          <div v-else class="text-center">There is no video</div>
        </vue-plyr>
        <div class="mt-3 mb-4" v-if="component === 'photos'">
          <MediaGallery
            v-if="imgIndex != null"
            :images="images"
            :mediaWithDetails=" galleryWithDetails"
            :startIndex="imgIndex"
            @close="closeGallery"
          />
          <div v-if="images.length">
            <img
              v-for="(image, index) in images"
              :key="index"
              class="event-high-img"
              :src="image"
              @click="imgIndex = index"
            />
          </div>
          <div v-else class="text-center">There is no image</div>
        </div>
        <div class="mt-3 mb-4" v-if="component === 'media'">
          <div v-if="event.post_guide" class="media-guide-area">
            <pdf
              class="pdf-show"
              :src="event.post_guide"
              :page="1"
              :resize="true"
              style="width: 100%"
            />
            <a
              :href="event.post_guide"
              target="_blank"
              :download="`Post_Event_Guide_${eventName(event.name)}`"
            >
              <div class="media-download">
                <i class="fa fa-download" aria-hidden="true"> </i>
               Post_Event_Guide_{{
                  eventName(event.name)
                }}{{ event.post_guide.slice(-4) }}
              </div>
            </a>
          </div>
          <p v-else class="text-center">There is no Guide file</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InfoAfterEvent from '../../../utils/mixins/InfoAfterEvent';
import MediaGallery from '../../pages/MediaArchive/MediaGallery.vue';

export default {
  mixins: [InfoAfterEvent],
  components: {
    MediaGallery,
  },
};
</script>

<style scoped>
.event-highlights-section {
  background-color: white;
  border-radius: 0 10px 10px 10px;
}
.tab-btn-active, .tab-btn{
  width: 42px;
  height: 40px;
  border-radius: 0 10px 10px 10px;
  padding: 2px 2px;
  border: unset;
  margin-top: 15px;

}
.tab-btn-active {
  color: white;
  background-color: #bd9d5f;

}
.tab-btn {
  color: #bd9d5f;
  background-color: #ebebeb;
}
.tab-btn-active > i,
.tab-btn > i {
  font-size: 16px;
  margin: 0px 2px;
}
.event-high-img {
  width: 95px;
  margin: 10px;
  height: 65px;
  object-fit: cover;
  cursor: pointer;
}
.event-statistics-img {
  width: 100%;
  margin: 10px;
  object-fit: cover;
}
.media-col {
  max-width: 235px;
  height: 79px;
  text-align: center;
  margin: 1px 20px 1px 20px;
  background: #bd9d5f;
}
.media-col > i {
  color: white;
  font-size: 30px;
  margin-top: 26px;
}
.media-download {
  background: #bd9d5f;
  color: white;
  text-align: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 0 0 10px 10px;
  overflow: hidden;
  font-size: 13px;
}
.media-guide-area {
  margin-top: 4px;
}
.media-download:hover {
  opacity: 0.5;
  transition: 0.3s;
}
button > p{
  margin: 0 0;
  font-family: Arial;
  font-size: 8px;
  line-height: 1.13;
  text-align: center;
}
.tab-btn-active > p{
  color: white;
}
</style>
